const getProcessedValue = (
  field:
    | {
        processed?: string | null | undefined;
      }
    | null
    | undefined,
) => field?.processed || '';

export default getProcessedValue;
